export default {
  exportRecords: '导出记录',
  exportDateRequired: '请先选择完整的时间范围再导出',
  exportDateInvalid: '导出时间范围必须有效，且不能超过31天',
  exportSubmitted: '导出任务已提交，完成后请在导出记录中下载',
  exportFailed: '导出失败，请重试',
  exportRefresh: '刷新',
  exportDownload: '下载',
  exportStatus: '导出状态',
  exportProgress: '已导出 / 总条数',
  exportStatuses: { PENDING: '等待中', GENERATING: '生成中', UPLOADING: '上传中', SUCCEEDED: '已完成', FAILED: '失败', EXPIRED: '已过期' },
  afterSaleList: '售后申请列表',
  afterDetails: '售后详情',
  // 筛选区域
  selectCountry: '选择国家',
  finishCloseTime: '完成/关闭时间',
  createdTime: '创建时间',
  reviewedTime: '审核时间',
  all: '所有',
  afterSaleNo: '售后单号',
  ticketStage: '工单阶段',
  userId: '用户ID',
  search: '搜索',
  export: '导出',
  pendingApprove: '待审核',
  pendingReviewConfirmation: '待审核确认',
  sellerRejected: '商家拒绝',
  sellerApproved: '商家通过',
  inProcessing: '进行中',
  done: '已完成',
  cancelled: '已取消',
  failed: '已终止(失败的)',
  rejected: '申请被拒',
  expectedSolution: '预期方案',
  amount: '涉及金额',
  orderNo: '订单号',
  createTime: '创建时间',
  remainingReviewTime: '还剩 {time}',
  timedOut: '已超时',
  merchantReviewTime: '商家审核时间',
  appealIF: '仲裁',
  platformSolution: '平台方案',
  qualityAdjustment: '质检调整',
  closeTime: '关闭时间',
  afterSaleStatus: '售后单状态',
  asStats: '售后单状态',
  operation: '操作',
  detail: '详情',
  processAction: '处理',

  // 时间选项
  days7: '7 Days',
  days30: '30 Days',
  MTD: 'MTD',
  YTD: 'YTD',
  TD: 'TD',
  userReview: '用户审核',
  merchantReview: '商家审核',
  platformArbitration: '平台仲裁',
  quality: '质检',
  returnGoods: '退回',
  delivery: '发货',
  pickUp: '揽收',
  refundAndReturn: '退款退货',
  refund: '仅退款',
  exchange: '换货',
  repair: '维修',
  resend: '补发',
  // 详情页
  originalOrderSummary: '原订单信息摘要',
  showMore: '查看更多',
  salesOrderNo: '销售订单号',
  billNo: '账单号',
  paymentOrderNo: '付款单号',
  orderAmount: '订单金额',
  actualPaid: '实际支付金额',
  orderTime: '下单时间',
  payTime: '支付时间',
  signTime: '签收时间',
  originalLogistics: '原单物流',
  track: '轨迹',
  logisticsTrackNo: '物流跟踪号',
  afterSaleDetail: '售后详情',
  latestSolution: '最新方案',
  statusLabel: '状态',
  user: '用户',
  relatedOrderNo: '关联订单号',
  product: '产品',
  applySolution: '申请方案',
  applyTime: '申请时间',
  sellerSolution: '商家方案',
  auditTime: '审核时间',
  reachedSolution: '达成方案',
  closeType: '关闭类型',
  ticketSummary: '工单信息摘要',
  noTicketInfo: '暂无工单信息',
  ticketStatus: '状态',
  processing: '处理中',
  pending: '待生效',
  effectTime: '生效时间',
  lastUpdateTime: '最后更新时间',
  userApplyInfo: '用户申请信息',
  faultInvolved: '故障涉及',
  issueItem: '故障项',
  dataUpdateTime: '该数据更新时间',
  intentSolution: '意向方案',
  applyReason: '申请原因',
  descriptionMedias: '描述/视频/照片',
  approved: '同意',
  review: '审核',
  submit: '提交',
  orderIdNotExist: '订单ID不存在',
  fetchDetailFailed: '获取详情失败',
  operationSuccess: '操作成功',
  operationFailed: '操作失败',
  afterSaleIdNotExist: '售后单ID不存在',
  noDetailPage: '当前工单类型[{type}]暂无独立详情页',
  // 服务类型
  serviceTypeReturn: '退货退款',
  serviceTypeRefund: '仅退款',
  serviceTypeExchange: '换货',
  serviceTypeRepair: '维修',
  serviceTypeResend: '补发',
  serviceTypeDefault: '拒绝',
  // 主状态
  statusPending: '待处理',
  statusProcessing: '处理中',
  statusCancel: '取消',
  statusDone: '售后完成',
  statusRejected: '申请被拒',
  statusFailed: '售后失败',
  // 步骤条
  stepApplied: '已申请',
  stepPendingSellerAudit: '待商家审核',
  stepSellerRejected: '商家已拒绝',
  stepSellerAudited: '商家已审核',
  stepStartProcessing: '开始处理',
  stepAfterSaleDone: '售后完成',
  // 关闭类型
  closeArbitrationRejected: '仲裁拒绝',
  closeSellerRejected: '商家拒绝',
  // 申诉状态
  appealPending: '待仲裁',
  appealRejected: '已拒绝',
  appealDone: '已仲裁',
  appealDetail: '申诉详情',
  appealStatus: '申诉状态',
  appealReason: '申诉原因',
  appealTime: '申诉时间',
  // 工单类型
  processStoreAudit: '商家审核',
  processPlatformAudit: '平台审核',
  processUserAudit: '用户审核',
  processReturn: '退货单',
  processInspection: '质检单',
  processRefund: '退款单',
  processExchange: '换货单',
  processRepair: '维修单',
  processResend: '补发单',
  processDelivery: '发货单',
  processCollection: '前置单',
  // 工单状态
  processStatusAccepted: '已接受',
  processStatusInvalid: '无效',
  processStatusQcReportIssued: '质检报告已出',
  processStatusDonePassed: '已完成(通过)',
  processStatusPendingIssue: '待下发',
  processStatusIssuedPendingConfirm: '已下发待确认',
  processStatusDispatched: '已派发',
  processStatusRepairerSigned: '维修商已签收',
  processStatusRepairDone: '维修完成',
  processStatusSendBack: '已寄回',
  processStatusPlatformReceived: '售后代理已签收',
  processStatusPendingShipCustomer: '待用户发货',
  processStatusSigned: '已签收',
  processStatusExpiredInvalid: '已过期/无效',
  processStatusPendingReceiving: '待收货',
  processStatusReceived: '已收货',
  processStatusApproved: '已通过',
  processStatusTimeoutFailure: '已超时/失败',
  // 补充
  productDetail: '商品详情',
  skuLabel: 'SKU',
  finishCloseTimeLabel: '关闭时间',
  pendingSellerApproved: '待商家审核',
  detailMore: '详情 >>',
  exchangeTargetInfo: '换货目标规格:',
  productId: '商品ID',
  // 发货单列表相关
  deliveryNoteList: '发货单列表',
  deliveryNoteNo: '发货单号',
  logisticsType: '物流方式',
  logisticsOrderNo: '物流单号',
  processedBy: '处理方',
  effectiveTime: '生效时间',
  dispatchTime: '发货时间',
  logisticsArrivedTime: '物流送达时间',
  deliveryStatus: '发货单状态',
  store: '店铺',
  pendingDispatch: '待发货',
  pendingArrived: '待送达',
  pendingSign: '待签收',
  pendingUserSign: '待用户签收',
  failedTimeout: '已超时/失效关闭',
  shopOrderNo: '商城订单号',
  deliveryLogisticsNo: '发货物流单号',
  platformLogistics: '平台物流',
  fbm: 'FBM',
  kiliExpress: 'KiliExpress',
  arrivedTime: '送达时间',
  seller: '商家',
  platformAgent: '平台代理',
  thirdParty: '三方服务商',
  type: '类型',
  afterRepair: '维修后',
  failedReturn: '失败 & 退回',
  storeId: '店铺ID',
  userPhone: '用户电话',
  logisticsPlatform: '物流平台',
  deliveryPanel: '发货面板',
  selectLogisticsProvider: '请选择物流商',
  confirm: '确认',
  deliverySuccess: '发货成功',
  deliveryFailed: '发货失败',
  logisticsOrderNoRequired: '请填写物流单号',
  logisticsProvider: '物流商',
  deliveryListAfterSaleNo: '售后单号',
  deliveryListUserId: '用户ID',
  deliveryListAsStatus: '售后单状态',
  deliveryListDispatchAction: '发货',
  deliveryListDispatchPanel: '发货面板',
  deliveryListDispatchBy: '发货方',
  outboundLogisticsList: '待收退件(来自售后代理)',
  selfPick: '自取',
  shipmentNo: '线外单号',
  shipmentType: '线外类型',
  outboundExchangeToStore: '发往商家',
  outboundRepairToProvider: '发往维修商',
  outboundRepairToPlatform: '退回(来自维修商)',
  outboundSelfPickup: '(自取)',
  upstreamOrder: '上游工单',
  maintenanceProvider: '维修服务商',
  passRequest: '通过请求',
  rejectRequest: '拒绝请求',
  audit: '审核',
  modifySolution: '修改方案',
  selectSolution: '请选择方案',
  refundAmount: '退款金额',
  selectAuditResult: '请选择审核结果',
  inputRefundAmount: '请输入退款金额',
  exceedMaxRefundAmount: '不能超过最大退款金额',
  userSelected: '用户选择',
  auditReason: '审核原因',
  selectAuditReason: '请选择审核原因',
  photos: '照片',
  remark: '备注',
  remarkPlaceholder: '请输入备注',
  reviewRemark: '审核备注',
  reviewPhotos: '审核照片',
  remainingTime: '剩余',
  cancelledBy: '取消方',
  cancelledReason: '取消原因',
  platform: '平台',
  logistics: '物流',
  customer: '用户',
  system: '系统自动',
  afterSalesSeq: '售后服务次数',
  timeOut: '售后超时',
  printListTip: '当前所选单已打印，您确定再次打印吗？',
  cancel: '取消',
  amountNum: '金额',
  afterSalesHistory: '售后历史',
  noHistoryRecords: '暂无历史记录',
  logisticsTrack: '物流轨迹',
  noLogisticsRecord: '暂无物流记录'

}
